export const HOME_APP_ROUTER_EXPERIMENT = 'car-merch-ui-home-app-router';

// App Router Home, served at '/' through a proxy rewrite; the server render can still see this pathname.
export const HOME_APP_ROUTER_PATHNAME = '/home-ar';

// RSC Home, served at '/' through a proxy rewrite only outside PROD when HOME_RSC_QUERY_PARAM is 'true'.
export const HOME_RSC_PATHNAME = '/home-rsc';
export const HOME_RSC_QUERY_PARAM = 'enableRSC';

export const isHomePathname = (pathname: string | null | undefined): boolean =>
  pathname === '/' ||
  pathname === HOME_APP_ROUTER_PATHNAME ||
  pathname === HOME_RSC_PATHNAME;

// Request headers the proxy forwards for `/`; always set by the proxy, so client-sent values are overwritten.
export const HOME_EXPERIMENTS_ERRORED_HEADER = 'x-home-experiments-errored';
export const HOME_PROXY_DEVICE_LOOKUP_HEADER = 'x-home-proxy-device-lookup';
export const HOME_ROUTER_REASON_HEADER = 'x-home-router-reason';

// Logged when Home calls device detection or split test after the proxy should already have covered it.
export const HOME_EXTRA_API_CALL_LOG = 'Home extra api call';

const homeRouterReasons = [
  'appRouterExperiment',
  'composer-override',
  'rsc',
  'sebs'
];

export type HomeRouterReason = (typeof homeRouterReasons)[number];

export const parseHomeRouterReason = (
  value: unknown
): HomeRouterReason | null =>
  homeRouterReasons.find(reason => reason === value) ?? null;
